<template>
    <div class="container">
        <h2 class="title is-5">アニメーションのサンプルコード</h2>
        <p>アニメーションのサンプルコードです</p>
        <b-tag type="is-info">Vue.js</b-tag>
        <hr/>
        <h3 class="title is-5">サンプル</h3>
        <transitionComponent />
        <hr/>
        <p class="title is-5">コード</p>
        <p style="margin-bottom:10px;"><b-button @click="twitterShare" class="is-info" size="is-small"><i class="fab fa-twitter"></i>シェアする</b-button></p>
        <div class="iframely-embed"><div class="iframely-responsive" style="padding-bottom: 56.2493%;"><a href="https://gist.github.com/katonobo/04c5047a8720a077a84e5f2e1c085dc4" data-iframely-url="//cdn.iframe.ly/7kP6Gxu"></a></div></div>
        <hr>
        <p class="title is-5">解説</p>
        <p>アニメーションのトランジションのサンプルコードです。</p>
        <p>ポイントは「transition」で要素を囲うこと、cssでトランジションの動作を指定することです。「v-enter-active」など、CSSクラスの名前は決まっています。</p>
        <p>詳しい指定方法は<a href="https://jp.vuejs.org/v2/guide/transitions.html">公式サイト</a>をご覧ください。</p>
    </div>
</template>

<script>
import transitionComponent from  '@/components/transitionComponent.vue'
export default {
    components:{
        transitionComponent
    },
    mounted(){
        const title = "アニメーションのサンプルコード｜あめねこサンプルコード集"
        const description = "Vue.jsで作るアニメーションのサンプルコードです"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    
        window.iframely.load();
    },
    methods:{
        twitterShare(){
            var shareURL = 'https://twitter.com/intent/tweet?text=' + "アニメーションのサンプルコード" + "%20%23あめねこサンプルコード集" + '&url=' + "https://code.ameneko.com/transition";  
            location.href = shareURL
        }
    }
}
</script>

<style scoped>
.container{
    max-width: 1000px;
    margin:auto;
    margin-bottom: 40px;
    padding: 10px;
}

</style>